var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuItemHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 19.385,
    viewBox: "0 0 18 19.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M11.7,19.385h-9A2.675,2.675,0,0,1,0,16.741V7.049a.878.878,0,0,1,.347-.7L8.448.186a.915.915,0,0,1,1.1,0l8.1,6.168a.878.878,0,0,1,.347.7v9.692a2.675,2.675,0,0,1-2.7,2.643Zm3.6-1.762a.891.891,0,0,0,.9-.881V7.48L9,2,1.8,7.48v9.262a.891.891,0,0,0,.9.881H5.4V9.692a.891.891,0,0,1,.9-.881h5.4a.891.891,0,0,1,.9.881v7.93Zm-4.5,0V10.573H7.2v7.049Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-0.254 -0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M11.7,19.385h-9A2.675,2.675,0,0,1,0,16.741V7.049a.878.878,0,0,1,.347-.7L8.448.186a.915.915,0,0,1,1.1,0l8.1,6.168a.878.878,0,0,1,.347.7v9.692a2.675,2.675,0,0,1-2.7,2.643Zm3.6-1.762a.891.891,0,0,0,.9-.881V7.48L9,2,1.8,7.48v9.262a.891.891,0,0,0,.9.881H5.4V9.692a.891.891,0,0,1,.9-.881h5.4a.891.891,0,0,1,.9.881v7.93Zm-4.5,0V10.573H7.2v7.049Z",
    transform: "translate(0.254 0.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11622",
    "data-name": "Group 11622",
    transform: "translate(0.254 0.379)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COLOR_black",
    "data-name": "COLOR/ black",
    transform: "translate(-2.084 -1.391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 20.783,
    height: 20.783,
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemHomeIcon);
export default __webpack_public_path__ + "static/media/menu-item-home-icon.522407f985a1cfa65a45ac3a8945a80d.svg";
export { ForwardRef as ReactComponent };